module.exports = __webpack_public_path__ + "components/outside-promo-page/static/snow-forecast__icon-f75874e1f4d7e6d28b1581199773ba48.svg";